__turbopack_context__.v({
  "SPathNoFill": "LOyGYa_SPathNoFill",
});
